module.exports = __webpack_public_path__ + "img/bachelor-energie-et-techniques-environnementales.7908867d.jpg";